import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Grid, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { Moment } from "moment";
import { FormInputProps } from "../../models/form.model";

export default function FormDateRange(props: FormInputProps) {
  const { name, control, label, helperText, rules, required, setError } = props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value = { from: null, to: null } },
          fieldState: { error },
          formState,
        }) => (
          <div>
            <Typography className="padding-b-normal" variant="subtitle2">
              {label}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <DatePicker
                  label={"From date"}
                  value={value.from}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                    },
                  }}
                  onChange={(newValue: Moment | null) => {
                    value.from = newValue;
                    onChange({ ...value });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DatePicker
                  label={"To date"}
                  value={value.to}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                    },
                  }}
                  onChange={(newValue: Moment | null) => {
                    value.to = newValue;
                    onChange({ ...value });
                  }}
                />
              </Grid>
            </Grid>
            <Typography>
              {error ? error.message : helperText || null}
            </Typography>
          </div>
        )}
      />
    </LocalizationProvider>
  );
}
